import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class CaseAvailabilityModel extends BaseModel {
  static urlPath = "user_contact_hours";

  @attr("number") day;
  @attr("string") timeStart;
  @attr("string") timeEnd;
  @attr("number") user;
}
